import { render, staticRenderFns } from "./DashboardSalesNumberDisplayer.vue?vue&type=template&id=380968f1"
import script from "./DashboardSalesNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./DashboardSalesNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports